import UsersView from '../views/UsersView.vue';

export default {
    path: '/users-manager', name: 'Users', component: UsersView,
    meta: {
        requiresAuth: true,
        roles: ["ADMIN"],
    },
}

